<template>
  <div class="lung-sound-check">
    <md-chip class="md-primary">If lung sounds were checked</md-chip>
  </div>
</template>

<script>
export default {
  name: 'lung-sound-assessed-check',
  components: {},
  props: [
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      state: {
        check: {
        },
      },
    };
  },
  created() {
    this.state.check = {
      ...this.state.check,
      ...(this.getData(this.ikey) || {}),
    };
    this.update();
  },
  methods: {
    update() {
      this.putData(this.ikey, {
        type: 'LUNG_SOUND_ASSESSED',
        operator: 'EQUAL',
        value: true,
      });
      this.emitter.trigger('process', this.control);
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
.lung-sound-check {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
